import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import {
	Link,
	Frame,
	Pic,
	Name,
	Caption,
	Price,
	Tag
} from './boxStyles';
import RatingStars from 'core/components/RatingStars';
import { stripTags } from 'core/utils/stringUtils';
import { renderPrice } from 'core/utils';

class Box extends PureComponent {
	render () {
		const {
			slug,
			name,
			img,
			stars,
			reviews,
			description,
			shippingInterval,
			startingPrice,
			currencySymbol,
			productCurrentQuantity,
			soldOut,
		} = this.props;

		let isSoldOut = soldOut;
		if (productCurrentQuantity !== null && productCurrentQuantity <= 0) {
			isSoldOut = true;
		}

		return (
			<Link href={`/subscription-box/${slug}/`} title={ stripTags(name) }>
				<Frame>
					<Pic alt={stripTags(name)} title={stripTags(name)} data-src={img} className="lazyload" width="350" height="400" />
					{isSoldOut && <Tag>Sold Out</Tag>}
				</Frame>

				<RatingStars stars={stars} reviews={reviews} short />
				<Name>{stripTags(name)}</Name>
				<Caption>{stripTags(description)}</Caption>
				{startingPrice && (
					<Price>
						From {renderPrice(startingPrice, currencySymbol)} {shippingInterval && `/ ${shippingInterval}`}
					</Price>
				)}
			</Link>
		);
	}

	static propTypes = {
		name: PropTypes.string,
		slug: PropTypes.string,
		img: PropTypes.string,
		stars: PropTypes.number,
		reviews: PropTypes.number,
		description: PropTypes.string,
		startingPrice: PropTypes.number,
		shippingInterval: PropTypes.string,
		currencySymbol: PropTypes.string,
		productCurrentQuantity: PropTypes.number,
		soldOut: PropTypes.bool,
	}
}

export default Box;
